import { createContext, useContext } from "react";

const context = createContext({});

const useCitizenContext = () => {
  const socialServiceContext = useContext(context);
  if (socialServiceContext === undefined) {
    throw new Error(`useCitizenContext must be used within a SocialServiceProvider`);
  }
  return socialServiceContext;
};

export { useCitizenContext };
export default context;
